import React from 'react';

export default function RiggingRuntimeRequirements({ requirements }) {
  if (!requirements) {
    return <p className="text-muted mb-0">Runtime requirements will appear after selections are complete.</p>;
  }

  const rows = [
    ['Maya version', requirements.maya_version],
    ['FabricatorStudio version', requirements.fabricatorstudio_version],
    ['AutoSkin model', requirements.autoskin_model_version || '—'],
    ['GPU required', requirements.gpu_required ? 'Yes' : 'No'],
    ['Min GPU memory (MB)', requirements.minimum_gpu_memory_mb || '—'],
    ['Min system memory (MB)', requirements.minimum_system_memory_mb || '—'],
    ['Min CPU count', requirements.minimum_cpu_count || '—'],
    ['Operating system', requirements.operating_system || '—'],
    [
      'Required capabilities',
      Array.isArray(requirements.required_capabilities)
        ? requirements.required_capabilities.filter(Boolean).join(', ')
        : '—',
    ],
  ];

  return (
    <dl className="row mb-0" data-testid="rigging-runtime-requirements">
      {rows.map(([label, value]) => (
        <React.Fragment key={label}>
          <dt className="col-sm-4">{label}</dt>
          <dd className="col-sm-8 mono">{value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}
